import { render, staticRenderFns } from "./CabinetPage.vue?vue&type=template&id=131c555d&scoped=true"
import script from "./CabinetPage.vue?vue&type=script&lang=js"
export * from "./CabinetPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131c555d",
  null
  
)

export default component.exports